/** backend AttachmentView */
export type AttachmentKind = "image" | "animated" | "video";

/**
 * presign時にクライアントが自己申告する添付の由来。backend AttachmentSourceと同じ値。
 * サーバーは真正性を検証しない自己申告値であり、表示専用の飾り(お絵かき証明バッジ等)にのみ使う。
 */
export type AttachmentSource = "file" | "paste" | "oekaki";

export interface Attachment {
  id: string;
  kind: AttachmentKind;
  mime: string;
  width: number | null;
  height: number | null;
  originalUrl: string;
  thumbnailUrl: string;
  ngHash: string | null;
  /** お絵かき機能由来の添付であることを示す表示専用フラグ (backend AttachmentView.isOekaki) */
  isOekaki: boolean;
}

/** Stable UI identity for an attachment within its owning post. */
export function getPostAttachmentIdentity(
  postId: string,
  attachment: Pick<Attachment, "id" | "originalUrl" | "thumbnailUrl">,
): string {
  const attachmentIdentity =
    attachment.id.trim() || attachment.originalUrl || attachment.thumbnailUrl;
  return `${postId}\u0000${attachmentIdentity}`;
}

/** Drop reveal/load identities that are no longer present after filtering. */
export function reconcileAttachmentIdentities(
  current: Set<string>,
  available: readonly string[],
): Set<string> {
  const availableSet = new Set(available);
  const next = new Set(
    Array.from(current).filter((identity) => availableSet.has(identity)),
  );
  return next.size === current.size ? current : next;
}
